"use strict";

exports.__esModule = true;
exports.TriggerTypeMap = exports.TriggerType = void 0;

var _utils = require("@bydesign-ui/utils");

var TriggerType = (0, _utils.tuple)('reset', 'change', 'blur', 'manual', 'force');
exports.TriggerType = TriggerType;
var TriggerTypeMap = TriggerType.reduce(function (map, item, index) {
  map[item] = index;
  return map;
}, {});
exports.TriggerTypeMap = TriggerTypeMap;